import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import { useSelector } from "react-redux";
import * as V from "styles/variables";

const ChartPictreeReviewTrend = () => {
  const trendData = useSelector((state) => state.pictree.reviewTrendBySeason);

  const option = useMemo(() => {
    if (!trendData) return {};

    // trendData が { OPERATOR_REVIEW_ONLY: Array<...> } のような形を想定
    let rows = [];

    if (Array.isArray(trendData)) {
      // もし将来的に「選択済みフローだけ Array で持つ」形に変えた場合もケア
      rows = trendData;
    } else if (typeof trendData === "object") {
      const keys = Object.keys(trendData);
      if (keys.length === 0) return {};
      const firstKey = keys[0]; // ひとまず最初の review_flow_type のみ表示
      rows = trendData[firstKey] || [];
    }

    if (!rows || rows.length === 0) return {};

    const formatBucketLabel = (bucketJst) => {
      if (typeof bucketJst !== "string") return "";
      if (bucketJst.length < 10) return bucketJst;

      const datePart = bucketJst.slice(0, 10);
      if (bucketJst.length >= 19) {
        const timePart = bucketJst.slice(11, 19); // HH:mm:ss
        if (timePart !== "00:00:00") {
          return bucketJst.slice(0, 16); // YYYY-MM-DD HH:mm
        }
      }
      return datePart;
    };

    // X 軸（日付）と各シリーズのデータを作成
    const xAxisData = rows.map((r) => formatBucketLabel(r.bucketJst));

    const completedSeriesData = rows.map((r) => Number(r.completedCount || 0));
    const uncompletedSeriesData = rows.map((r) => Number(r.uncompletedCount || 0));

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      legend: {
        data: ["レビュー完了数", "レビュー未完了数"],
      },
      grid: {
        left: 64,
        top: 48,
        right: 48,
        bottom: 32,
      },
      xAxis: {
        type: "category",
        data: xAxisData,
      },
      yAxis: {
        type: "value",
        name: "レビュー件数",
      },
      color: V.genericColorPallette,
      series: [
        {
          name: "レビュー完了数",
          type: "bar",
          stack: "total",
          emphasis: { focus: "series" },
          data: completedSeriesData,
          barMaxWidth: 40,
        },
        {
          name: "レビュー未完了数",
          type: "bar",
          stack: "total",
          emphasis: { focus: "series" },
          data: uncompletedSeriesData,
          barMaxWidth: 40,
        },
      ],
    };
  }, [trendData]);

  return (
    <ReactEcharts
      option={option}
      theme="BarChartTheme"
      style={{ height: 400, width: "100%" }}
    />
  );
};

export default ChartPictreeReviewTrend;
